import { ContractDetailContractVersionFragment } from 'generated/resources/graphql'

import type EmployeeContract from 'modules/contracts/lib/EmployeeContract'
import calculateEmployeeContracts from 'modules/contracts/lib/calculateEmployeeContracts'

interface EmployeeContracts {
  contracts: EmployeeContract[]
  selectedContract?: EmployeeContract
  nextContract?: EmployeeContract
  previousContract?: EmployeeContract
}

const useEmployeeContracts = (
  selectedContractVersionId: number,
  sortedContractVersions: ContractDetailContractVersionFragment[]
): EmployeeContracts => {
  const contracts = calculateEmployeeContracts(sortedContractVersions)

  // Find the contract band that contains the selected version
  const selectedContract = contracts.find((contract) =>
    contract.includesVersion(selectedContractVersionId)
  )

  // Find next and previous contracts (for navigation)
  const selectedIndex = contracts.findIndex((contract) =>
    contract.includesVersion(selectedContractVersionId)
  )

  const nextContract = selectedIndex > 0 ? contracts[selectedIndex - 1] : undefined
  const previousContract =
    selectedIndex < contracts.length - 1 ? contracts[selectedIndex + 1] : undefined

  return {
    contracts,
    selectedContract,
    nextContract,
    previousContract,
  }
}

export default useEmployeeContracts
